const angular = require('angular');

const { transcludeInjectDirectiveDefinition } = require('./transclude-inject.directive');

angular.module('oly.common')
    .directive('transcludeInject', transcludeInjectDirectiveDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/transcludeinject/index.js